import useWindowDimensions from './use_window_dimensions'

const breakpoints = {
  xs: 480,
  sm: 768,
  md: 976,
  lg: 1440,
  xl: 2560,
}

type Breakpoints = keyof typeof breakpoints

export const useGetCurrentBreakpoint = (): Breakpoints => {
  const { width } = useWindowDimensions()

  const [key] = Object.entries(breakpoints).find(([_, breakpoint]) => width < breakpoint) ?? 'xl'

  return key as Breakpoints
}
